<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Order List
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="list"
      :options.sync="options"
      :server-items-length="total"
      :loading="loader"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  :items="clients"
                  outlined
                  v-model="client"
                  dense
                  chips
                  small-chips
                  label="Client"
                  :loading="clientsLoader"
                  item-text="name"
                  item-value="id"
                  @click:clear="clearInput('client')"
                  @focus="fetchClients"
                  @input="getDropdown(client)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Sale Order Code"
                  v-model="sale_order_code"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(created)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.created')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="created"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  class="custom-text-field"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(updated)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.updated')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="updated"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  v-model="sale_order_details_status"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Order Status"
                  item-value="value"
                  item-text="text"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="SKU"
                  v-model="skuvalue"
                  outlined
                  clearable
                  @click:clear="clearInput('skuvalue')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="deliveryType"
                  :items="deliveryTypes"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Delivery Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="dutyhandling"
                  :items="dutyhandlings"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Duty Handling"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-select
                  v-model="channel"
                  label="Channel"
                  :items="channelList"
                  item-text="channel_name"
                  item-value="channel_name"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                class="mb-2"
                :class="[
                  userCategory.user_category === 3
                    ? 'offset-md-6'
                    : 'offset-md-9',
                ]"
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mb-2 mt-2"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.duty_handling`]="{ item }">
        {{ item.duty_handling ? item.duty_handling.toUpperCase() : "" }}
      </template>

      <template v-slot:[`item.delivery_type`]="{ item }">
        <span v-if="item.delivery_type">{{
          capitalizeFirstLetter(item.delivery_type)
        }}</span>
      </template>
      <template v-slot:[`item.service_name`]="{ item }">
        <span v-if="item.service_name">{{ item.service_name }} -</span>
        <span v-if="item.service_type"> ({{ item.service_type }})</span>
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <span v-if="item.created">{{
          item.created | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        <span v-if="item.updated">{{
          item.updated | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.total_price`]="{ item }">
        {{ item.total_price }} {{ item.currency_code }}
      </template>
      <template v-slot:[`item.sale_order_code`]="{ item }">
        <a @click="gotodetails(item.sale_order_code)">{{
          item.sale_order_code
        }}</a>
      </template>

      <template v-slot:[`item.sale_order_details_status`]="{ item }">
        <span v-if="item.status_code">{{ item.status_code }}</span>
        <span v-else>{{ item.sale_order_details_status }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_ecom_vendors:aev__order_details')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="findSummary(item.id)">
              mdi-archive-check-outline
            </v-icon>
          </template>
          <span>Order Summary</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <template>
      <v-row justify="center">
        <v-dialog v-model="summary" persistent width="700">
          <v-card class="pl-0">
            <v-card-title class="card-title"
              >Order Summary-{{ orderSummaryData.order_id }} ({{
                orderSummaryData.client_name
              }})
              <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div>
                      <b>Order Details </b>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0 text-medium-emphasis">
                        Customer
                      </div>
                      <div class="text-left col-md-7 p-0">
                        {{ orderSummaryData.order_details.customer }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Channel</div>
                      <div class="text-left col-md-7 p-0">
                        {{ orderSummaryData.order_details.channel }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Order Status</div>
                      <div class="text-left col-md-7 p-0">
                        <span v-if="orderSummaryData.status_code">{{
                          orderSummaryData.status_code
                        }}</span>
                        <span v-else>{{
                          orderSummaryData.sale_order_details_status
                        }}</span>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Display order code</div>
                      <div class="text-left col-md-7 p-0">
                        {{ orderSummaryData.display_order_code }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Order Amount</div>
                      <div class="text-left col-md-7 p-0">
                        {{ orderSummaryData.order_details.order_amount }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Order Date</div>
                      <div class="text-left col-md-7 p-0">
                        {{
                          orderSummaryData.order_details.order_date
                            | uaeDateTime
                            | moment("DD MMM, YYYY hh:mm A")
                        }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Fulfillment TAT</div>
                      <div class="text-left col-md-7 p-0">
                        {{
                          orderSummaryData.order_details.fulfillment_tat
                            | uaeDateTime
                            | moment("DD MMM, YYYY hh:mm A")
                        }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Duty Handling</div>
                      <div class="text-left col-md-7 p-0">
                        {{
                          orderSummaryData.duty_handling
                            ? orderSummaryData.duty_handling.toUpperCase()
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Delivery Type</div>
                      <div class="text-left col-md-7 p-0">
                        {{ orderSummaryData.delivery_type }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Payment Details</b></div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        Payment Method
                      </div>
                      <div class="text-left col-md-6 p-0">
                        {{ orderSummaryData.order_details.payment_method }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Order Currency</div>
                      <div class="text-left col-md-6 p-0">
                        {{ orderSummaryData.currency_code }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Billing Address</b></div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="text-left col-md-6 p-0">
                        {{ orderSummaryData.billing_address.name }}
                        {{ orderSummaryData.billing_address.addressLine1 }}
                        ,
                        {{ orderSummaryData.billing_address.addressLine2 }}
                        <br />
                        {{ orderSummaryData.billing_address.city }},
                        {{ orderSummaryData.billing_address.state }}
                        {{ orderSummaryData.billing_address.country }}
                        <br />
                        {{ orderSummaryData.billing_address.phone }}
                        {{ orderSummaryData.billing_address.email }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Shipping Address</b></div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="text-left col-md-6 p-0">
                        {{ orderSummaryData.shipping_address.name }}
                        {{ orderSummaryData.shipping_address.addressLine1 }}
                        ,
                        {{ orderSummaryData.shipping_address.addressLine2 }}
                        <br />
                        {{ orderSummaryData.shipping_address.city }},
                        {{ orderSummaryData.shipping_address.state }}
                        {{ orderSummaryData.shipping_address.country }}
                        <br />
                        {{ orderSummaryData.shipping_address.phone }}
                        {{ orderSummaryData.shipping_address.email }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col class="pl-0">
                  <v-data-table
                    :headers="itemheaders"
                    :items="orderDetails"
                    disable-pagination
                    :hide-default-footer="true"
                    class="custom-class"
                  >
                    <template v-slot:[`item.item_sku`]="{ item }">
                      <label>
                        {{ item.item_sku }}
                      </label>
                    </template>
                    <template v-slot:[`item.item_value`]="{ item }">
                      <label>
                        {{ item.item_value }} ({{ item.item_currency }})
                      </label>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="white" variant="text" @click="summary = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client"
          : true;
      });
    },
    ...mapGetters(["userRole", "userCategory", "currencyList"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    list: [],
    orderDetails: {},
    currency_code: "",
    created: "",
    updated: "",
    shipping_country: "",
    dateMenu: false,
    dateMenuTo: false,
    itemheaders: [
      { text: "Item", value: "item_sku", sortable: false },
      { text: "Description", value: "item_name", sortable: false, width: 200 },
      { text: "Hs Code", value: "hs_code", sortable: false },
      { text: "Batch Code", value: "batch_code", sortable: false },
      {
        text: "Inbound Boe Number",
        value: "inbound_boe_number",
        sortable: false,
      },
      { text: "Inbound Coo", value: "inbound_coo", sortable: false },

      { text: "Dimansion(in cm)", value: "item_dimension", sortable: false },
      { text: "Qty", value: "item_qty", sortable: false },
      { text: "Weight(In Kg)", value: "item_weight", sortable: false },

      { value: "item_value", text: "Item value", sortable: false },

      { value: "item_status", text: "Status", sortable: false },
    ],
    statuses: [
      {
        text: "PROCESSING",
        value: "PROCESSING",
      },
      {
        text: "CREATED",
        value: "CREATED",
      },
      {
        text: "CANCELLED",
        value: "CANCELLED",
      },
      {
        text: "COMPLETE",
        value: "COMPLETE",
      },
      {
        text: "UNFULFILLABLE",
        value: "UNFULFILLABLE",
      },
      {
        text: "PARTALLY UNFULFILLABLE",
        value: "PARTALLY_UNFULFILLABLE",
      },
    ],
    headers: [
      {
        text: "Client",
        value: "client",
        class: "body-1 font-weight-bold",
        align: "left",
        width: "150px",
        sortable: false,
      },
      {
        text: "Order #",
        value: "sale_order_code",
        class: "body-1 font-weight-bold",
        align: "left",
        width: "150px",
        sortable: false,
      },

      {
        text: "Order Date Time",
        value: "created",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: "200px",
      },
      {
        text: "Order Status",
        value: "sale_order_details_status",
        class: "body-1 font-weight-bold",
        align: "left",
        width: "100px",
        sortable: false,
      },
      {
        text: "Order Updated Date",
        value: "updated",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Shipping Country",
        value: "shipping_country",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Payment Method",
        value: "payment_method",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Channel",
        value: "channel",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Delivery Type",
        value: "delivery_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Service Name",
        value: "service_name",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "200px",
      },
      {
        text: "Duty Handling",
        value: "duty_handling",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Total Value",
        value: "total_price",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Action",
        value: "actions",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    trackingPage: false,
    display_order_code: "",
    sale_order_code: "",
    sale_order_details_status: "",
    clients: [],
    skuvalue: null,
    summary: false,
    orderSummaryData: {
      payment_summary: {},
      order_details: {},
      shipping_address: {},
      billing_address: {},
    },
    client: null,
    clientsLoader: false,
    channel: null,
    channelList: [],
    loader: false,
    dutyhandlings: [
      {
        text: "DDU",
        value: "ddu",
      },
      {
        text: "DDP",
        value: "ddp",
      },
    ],
    deliveryTypes: [
      {
        text: "Crossborder",
        value: "crossborder",
      },
      {
        text: "Domestic",
        value: "domestic",
      },
    ],
    dutyhandling: null,
    deliveryType: null,
  }),

  watch: {
    options: {
      handler() {
        this.fetchOrderList();
      },
      deep: true,
    },
  },
  created() {
    if (this.userCategory.user_category == 1) {
      this.getDropdown(this.$store.getters.user.id);
    }
    this.fetchClients();
  },
  methods: {
    ...mapActions([
      "getOrdersList",
      "getCurrencyList",
      "fetchClient",
      "orderSummaryview",
      "getChannelDropdown",
    ]),
    getDropdown(id) {
      if (id)
        this.getChannelDropdown(id).then((res) => {
          this.channelList = res.data;
        });
    },
    clearDateInput(val) {
      if (val == "this.updated") {
        this.updated = null;
      } else if (val == "this.created") {
        this.created = null;
      }
    },
    gotodetails(value) {
      window.open(
        this.$router.resolve({
          name: "OrderList",
          query: {
            value: value,
          },
        }).href,
        "_blank"
      );
    },
    fetchClients() {
      if (this.clients.length) return;

      if (this.userCategory.user_category === 3 && this.clients.length == 0) {
        this.clientsLoader = true;
        this.fetchClient({
          pagination: 0,
          fields: "id,name",
          service: "fulfillment_wid_last_mile,fulfillment",
        })
          .then((res) => {
            this.clientsLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientsLoader = false;
          });
      } else {
        this.userTrue = true;
      }
    },
    fetchOrderList() {
      this.pgList = [];
      this.loader = true;
      let data = {
        client_id: this.$route.params.id,
        sale_order_details_status: this.$route.params.value,
      };
      if (this.$route.params.id !== undefined) {
        this.sale_order_details_status = this.$route.params.value;
        this.client = this.$route.params.id;
        this.getOrdersList({
          ...this.options,
          ...this.filtersArr,
          ...data,
        })
          .then((res) => {
            this.loader = false;
            this.list = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        this.getOrdersList({
          ...this.options,
          ...this.filtersArr,
        })
          .then((res) => {
            this.loader = false;
            this.list = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.loader = false;
          });
        this.loader = false;
      }
    },
    clearInput(val) {
      if (val == "OrderCode") {
        this.OrderCode = "";
      } else if (val == "client") {
        this.client = "";
      } else if (val == "shippingStatus") {
        this.shippingStatus = "";
      } else if (val == "skuvalue") {
        this.skuvalue = "";
      } else if (val == "channel") {
        this.channel = "";
      }
    },
    clearAll() {
      (this.created = ""),
        (this.updated = ""),
        (this.sale_order_code = ""),
        (this.sale_order_details_status = ""),
        (this.client = ""),
        (this.skuvalue = null);
      this.channel = null;
      this.deliveryType = "";
      this.dutyhandling = "";
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        sale_order_code: this.sale_order_code,
        sale_order_details_status: this.sale_order_details_status,
        from_date: this.created,
        to_date: this.updated,
        client_id: this.client,
        item_sku: this.skuvalue,
        channel: this.channel,
        delivery_type: this.deliveryType,
        duty_handling: this.dutyhandling,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.loader = true;

      this.options.page = 1;
      this.allFilters();
      this.getOrdersList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.list = [];
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    findSummary(id) {
      let payload = {
        order_id: id,
      };
      this.orderSummaryview(payload).then((res) => {
        this.orderSummaryData = res.data.data;
        this.summary = true;
        this.orderDetails = Object.values(res.data.data.order_items);
      });
    },
  },
};
</script>

<style lang="scss">
.custom-button:hover {
  background-color: #e7e7e724 !important;
  z-index: 0;
}
.v-btn--icon.v-size--default {
  height: 25px;
  width: 25px;
}

.p-0 {
  padding: 0px !important;
}

.layout.wrap.pt-3 {
  padding-left: 38px !important;
}
.card-title {
  padding-left: 22px;
}
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}
.tl-item {
  margin: 0;
  padding: 0;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 45px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}
.history-tl-container-order-details {
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 36.5%;
  display: block;
  position: relative;
}
.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px;
  line-height: 1px;
}
.history-tl-container-order-details ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 10px 20px;
  // position: relative;
  line-height: 1px;
}

.height-order {
  height: 40px !important;
}
.tracingNo {
  font-size: 12px;
  float: right;
}
/* Icon with horizontal lines */
.icon-inside {
  position: relative; /* Ensure proper positioning */
  display: inline-block; /* Allow lines to be displayed correctly */
  color: black; /* Icon color */
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 16px;
  left: 43%;
  transform: translateX(-50%);
  height: 33px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}
</style>
